import { useMemo } from 'react'
import { leftSideHooks } from 'shared/hooks'

import { api } from '../api'
import { SIDEBAR_ITEMS, TeamSideId } from '../const'
import { useHasInvited } from './useHasInvited'
import { useIsEnable } from './useIsEnable'

export function useSidebar() {
	const showMembers = useIsEnable()
	// ! Don't delete to init fetch
	api.usePersonasQuery(undefined, {
		skip: !showMembers
	})

	const hasInvited = useHasInvited()

	const leftSide = useMemo<leftSideHooks.LeftSideInput>(() => {
		const bottomList = [SIDEBAR_ITEMS[TeamSideId.Members]]

		if (showMembers) {
			bottomList.push(SIDEBAR_ITEMS[TeamSideId.Statistics])
		}
		if (hasInvited) {
			bottomList.push(SIDEBAR_ITEMS[TeamSideId.Invites])
		}

		return { bottomList, type: 'team' }
	}, [showMembers, hasInvited])

	leftSideHooks.useLeft(leftSide)
}
